import { LoginApi } from "@/api";
import { showSuccessSnackbar } from "@/utilities/snackbar";
import i18n from "@/i18n";

export async function authorize(email, password) {
  const { data } = await LoginApi.authorize(email, password);
  return data;
}

export async function requestPassword(password) {
  await LoginApi.requestPassword(password);
  showSuccessSnackbar(200, i18n.t("password-request-success"));
}

export async function requestPasswordValidate(email, token) {
  await new Promise((resolve) => setTimeout(resolve, 500));
  await LoginApi.requestPasswordValidate(email, token);
  showSuccessSnackbar(200, i18n.t("password-request-success"));
}
